import React from 'react'
import Navbar from '../../Components/Navbar'

function Mobile() {
    return (
        <div>
            <Navbar/>
            <h1>Mobiles.</h1>
        </div>
    )
}

export default Mobile
